module.exports = __webpack_public_path__ + "static/media/awsar.e12625ad.png";